import { render, staticRenderFns } from "./BrowserWarning.vue?vue&type=template&id=62dface6&scoped=true"
import script from "./BrowserWarning.vue?vue&type=script&lang=js"
export * from "./BrowserWarning.vue?vue&type=script&lang=js"
import style0 from "./BrowserWarning.vue?vue&type=style&index=0&id=62dface6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dface6",
  null
  
)

export default component.exports